function getQueryParams(key: string): string[] {
  if (typeof window === "undefined") return [];

  try {
    const searchParams = window.location.search.substring(1);
    if (!searchParams) return [];

    return searchParams
      .split("&")
      .filter((param) => param.length > 0)
      .map((param) => {
        const [paramKey, paramValue] = param.split("=");
        return {
          key: decodeURIComponent(paramKey),
          value: paramValue ? decodeURIComponent(paramValue) : "",
        };
      })
      .filter((item) => item.key === key)
      .flatMap((item) => item.value.split(","))
      .filter((value) => value.length > 0);
  } catch (error) {
    return [];
  }
}

export default getQueryParams;
